export const SVGDefs = () => {
  return (
    <defs>
      <pattern
        id='pattern-circles'
        x='0'
        y='0'
        width='4'
        height='4'
        patternUnits='userSpaceOnUse'
        patternContentUnits='userSpaceOnUse'
      >
        <rect
          id='pattern-rect'
          x='0'
          y='0'
          width='4'
          height='4'
          fill='var(--gray-4)'
        />
        <circle id='pattern-circle' cx='2' cy='2' r='.75' fill='#fff'></circle>
      </pattern>
      <filter id='my-filter' x='-10' y='-10' width='200' height='200'>
        {' '}
        <feOffset result='offOut' in='SourceAlpha' dx='0' dy='0' />{' '}
        <feColorMatrix
          result='matrixOut'
          in='offOut'
          type='matrix'
          values=' 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0'
        />{' '}
        <feGaussianBlur result='blurOut' in='matrixOut' stdDeviation='4' />{' '}
        <feBlend in='SourceGraphic' in2='blurOut' mode='normal' />{' '}
      </filter>
      <pattern
        id='diagonalHatch'
        x='0'
        y='0'
        width='4'
        height='4'
        patternUnits='userSpaceOnUse'
      >
        <rect width={8} height={8} fill='#fff' />
        <path
          d='M-1,1 l2,-2
        M0,4 l4,-4
        M3,5 l2,-2'
          stroke='var(--brandblue-bright-4)'
          strokeWidth='0.5'
        />
      </pattern>
    </defs>
  )
}
